import React from 'react';
export default function NumberInput(_ref) {
  var number = _ref.number,
    setNumber = _ref.setNumber,
    type = _ref.type,
    step = _ref.step,
    min = _ref.min,
    max = _ref.max,
    decimalPrecision = _ref.decimalPrecision;
  var numberType = type || 'integer';
  var precision = decimalPrecision || 2;
  var numberStep = step || (numberType === 'integer' ? step ? parseInt(step) : 1 : step ? parseFloat(step).toFixed(precision) : 0.1);
  var numberMin = min || 0;
  function handleChangeInput(event) {
    var value = event.target.value;
    var regex = new RegExp(/^\d*$/);
    if (numberType !== 'integer') {
      if (decimalPrecision) {
        regex = new RegExp("^(\\d+\\.?\\d{0,".concat(decimalPrecision, "})?$"));
      } else {
        regex = new RegExp(/^(\d+\.?\d*)?$/);
      }
    }
    if (value.match(regex)) {
      if ((parseFloat(value) || 0) < numberMin) {
        return;
      }
      if (max !== undefined && (parseFloat(value) || 0) > max) {
        return;
      }
      setNumber(numberType === 'integer' ? parseInt(value) || '' : value);
    }
  }
  function handleIncrease() {
    var nextState = numberStep;
    if (number) {
      if (!max || max && parseFloat(number) + numberStep <= max) {
        nextState = parseFloat(number) + numberStep;
      } else {
        nextState = max;
      }
    }
    if (nextState < numberMin) {
      nextState = numberMin;
    }
    setNumber(numberType === 'integer' ? parseInt(nextState) : nextState.toFixed(precision));
  }
  function handleDecrease() {
    var nextState = 0;
    if (number) {
      if (parseFloat(number) - numberStep >= numberMin) {
        nextState = parseFloat(number) - numberStep;
      } else {
        nextState = numberMin;
      }
    }
    setNumber(numberType === 'integer' ? parseInt(nextState) : nextState.toFixed(precision));
  }
  function handleArrow(event) {
    if (event.key === 'ArrowUp') {
      handleIncrease();
    } else if (event.key === 'ArrowDown') {
      handleDecrease();
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "number-input"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: number,
    onChange: handleChangeInput,
    onKeyDown: handleArrow
  }), /*#__PURE__*/React.createElement("div", {
    className: "actions flex-box content-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "action up fa-light fa-sort-up",
    onClick: handleIncrease
  }), /*#__PURE__*/React.createElement("i", {
    className: "action down fa-light fa-sort-down",
    onClick: handleDecrease
  })));
}